import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Arbor } from "../../models/Arbor";
import { getArbors } from "../../repositories/ArborRepository";
import { TableArbor } from "./components/TableArbor";

type useArborsProps = {
	partId?: number;
	onError?: (error: Error) => void;
};

export const useArbors = ({ partId, onError }: useArborsProps) => {
	return useQuery<Arbor[], Error>({
		queryKey: ["arbors", partId],
		meta: { realtime: ["M2.GetArbors"] },
		queryFn: ({ signal }) => getArbors({ partId }, signal),
		onError: onError,
	});
};

export const ArborPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Arbors" />
			<TableArbor partId={partId} />
		</>
	);
};
